<template>
   <div class="AboutOOPVR">
       {{name}}
   </div>
</template>

<script>
export default {
  name:'aboutoopvr',
  data() {
    return {
      name:'关于OOPVR',
    }
  },

}
</script>

<style lang="less" scoped>
.AboutOOPVR{
  width:100%;
  height:2000px;
  background-color:chocolate;
}
</style>


// WEBPACK FOOTER //
// src/components/column/aboutoopvr.vue